var render, staticRenderFns
import script from "./Pagination.vue?vue&type=script&lang=tsx&"
export * from "./Pagination.vue?vue&type=script&lang=tsx&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=6235f072&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235f072",
  null
  
)

export default component.exports